import React from 'react';
import { roadmapModules } from '../mockData';

const WhatWeBuildSection = () => {
  return (
    <section className="py-20 px-4 bg-[#061018] relative overflow-hidden">
      {/* Abstract background elements */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="abstract-blob animate-float-slow" style={{ 
          top: '10%', 
          left: '20%', 
          width: '450px', 
          height: '450px', 
          background: 'radial-gradient(circle, rgba(255, 140, 50, 0.25), transparent 70%)',
          filter: 'blur(70px)'
        }}></div>
        <div className="abstract-blob animate-float" style={{ 
          bottom: '15%', 
          right: '15%', 
          width: '400px', 
          height: '400px', 
          background: 'radial-gradient(circle, rgba(255, 101, 0, 0.2), transparent 70%)',
          filter: 'blur(80px)'
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 text-center">
          How Augmented Cinematic Materials <span className="text-[#FF6500]">Are Used</span>
        </h2>
        <p className="text-xl text-[#aaa] text-center mb-16 max-w-3xl mx-auto">
          A modular approach to activating your story through strategic content deployment.
        </p>
        
        <div className="grid md:grid-cols-2 gap-8">
          {roadmapModules.map((module, index) => {
            return (
              <div 
                key={index}
                className="bg-[#0a1525] rounded-lg border border-[#152840] hover:border-[#FF6500]/30 transition-all duration-300 overflow-hidden hover:transform hover:-translate-y-1"
              >
                {/* Image at top */}
                <div className="aspect-video w-full overflow-hidden">
                  <img 
                    src={module.image} 
                    alt={module.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                
                {/* Content below image */}
                <div className="p-8">
                  <h3 className="text-2xl font-semibold text-white mb-6">{module.title}</h3>
                  
                  <div className="space-y-4">
                    <div>
                      <h4 className="text-sm font-semibold text-[#FF6500] uppercase tracking-wider mb-2">Goal</h4>
                      <p className="text-base text-[#aaa] leading-relaxed">{module.goal}</p>
                    </div>
                    
                    <div>
                      <h4 className="text-sm font-semibold text-[#FF6500] uppercase tracking-wider mb-2">How it's used</h4>
                      <p className="text-base text-[#aaa] leading-relaxed">{module.howUsed}</p>
                    </div>
                    
                    <div>
                      <h4 className="text-sm font-semibold text-[#FF6500] uppercase tracking-wider mb-2">Why it matters</h4>
                      <p className="text-base text-[#aaa] leading-relaxed">{module.whyItMatters}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeBuildSection;